import { render } from "./GhostFestival.vue?vue&type=template&id=1ae64136&ts=true&lang=pug"
import script from "./GhostFestival.vue?vue&type=script&lang=ts"
export * from "./GhostFestival.vue?vue&type=script&lang=ts"

import "./GhostFestival.vue?vue&type=style&index=0&id=1ae64136&lang=stylus"

import exportComponent from "/builds/CarrefourOneAPP/website/game/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__